import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '@/components/Home.vue';
import AboutPage from '@/components/About.vue';
import EcosystemPage from '@/components/Ecosystem.vue';
import InHospitalPage from '@/components/InHospital.vue';
import OutHospitalPage from '@/components/OutHospital.vue';
import AboutUsPage from '@/components/AboutUs.vue';
import OnCallCareAppPage from '@/components/OnCallCareApp.vue';
import SupportPage from '@/components/Support.vue';
Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: AboutPage
    },
    {
      path: '/ecosystem',
      name: 'EcosystemPage',
      component: EcosystemPage
    },
    {
      path: '/in-hospital',
      name: 'InHospitalPage',
      component: InHospitalPage
    },
    {
      path: '/out-hospital',
      name: 'OutHospitalPage',
      component: OutHospitalPage
    },
    {
      path: '/about-us',
      name: 'AboutUsPage',
      component: AboutUsPage
    },
    {
      path: '/OnCallCareApp',
      name: 'OnCallCareAppPage',
      component: OnCallCareAppPage
    },
    {
      path: '/Support',
      name: 'SupportPage',
      component: SupportPage
    }
  ]
});